<template>
  <div class="dialog-root">
    <div class="container">
      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="listData"
        :page.sync="tablePage"
        @on-load="loadData"
      >
      </avue-crud>
    </div>
  </div>
</template>

<script>
import { getLogPageListApi } from '@/api/call-system/call-manage/outbound-task';

export default {
  name: 'LogDialog',
  props: ['projectId', 'rowData'],
  data() {
    return {
      // 列表数据
      listData: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '电话号码',
            prop: 'phone',
          },
          {
            label: '完成状态',
            prop: 'callStatusName',
          },
          {
            label: '外呼时间',
            prop: 'callTime',
          },
        ],
      },
    };
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      getLogPageListApi({
        current: page.currentPage,
        size: page.pageSize,
        projectId: this.projectId,
        taskId: this.rowData.id,
      }).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
}

/* 表格上方按钮栏未配置内容时依然占着位置，会产生一个很大的空白区域，需要去掉 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
